import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type ApiBrokeredLoadSalesOrderLineItem = QueryAtomResult<
  typeof brokeredLoadSalesOrderLineItemsQueryAtom
>[number];

export const brokeredLoadSalesOrderLineItemsQueryAtom = createQueryAtomFactory(
  'brokerage.salesOrderLineItems',
  (params: { salesOrderId: string }) => ({
    salesOrders: {
      __args: {
        filter: {
          includeLineItems: true,
          ids: [params.salesOrderId],
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        lineItems: {
          id: true,
          item: {
            id: true,
            name: true,
          },
          unit: true,
          unitPrice: {
            amount: true,
            currencyCode: true,
          },
          quantity: true,
        },
      },
    },
  }),
  {
    select: (data) => data?.salesOrders?.entries?.[0]?.lineItems ?? [],
  },
);
